import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from '@/redux/action';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import { request } from '@/api/request';
import AudioCompressWorkFunction from './children/audioCompressWorkFunction/AudioCompressWorkFunction';
import AudioCompressCompleteFunction from './children/audioCompressCompleteFunction/AudioCompressCompleteFunction';
import '@/assets/audioCompress.less';
import moment from 'moment';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';

class AudioCompressWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioCompressAfterList: [],
      submitStatus: null,
      compressing: false,
    };
  }

  deleteAudioCompressItem = (guid) => {
    sentGAEvent({
      category: 'audio_compress_add_files',
      action: 'audio_compress_add_files_delete',
    });
    const audioCompressList = [...this.props.audioCompressList];
    for (let i = 0; i < audioCompressList.length; i++) {
      if (audioCompressList[i].guid === guid) {
        audioCompressList.splice(i, 1);
      }
    }
    this.props.onAudioCompressListChange(audioCompressList);
  };

  deleteAudioCompressAfterItem = (guid) => {
    const audioCompressAfterList = [...this.state.audioCompressAfterList];
    for (let i = 0; i < audioCompressAfterList.length; i++) {
      if (audioCompressAfterList[i].guid === guid) {
        audioCompressAfterList.splice(i, 1);
      }
    }
    this.setState({ audioCompressAfterList });
  };

  handleSubmitAgain = () => {
    this.setState({ audioCompressAfterList: [] }, () =>
      this.handleSubmit(this.state.format, this.state.quality)
    );
  };

  handleSubmit = async (format, quality) => {
    let startTime = new Date().getTime();
    this.setState({ format, quality, compressing: true });
    const audioCompressAfterList = [...this.props.audioCompressList];
    this.props.onProcessStepChange(audioCompressAfterList.length * 3);
    let audioItemSizes = '';
    audioCompressAfterList.forEach((item) => {
      audioItemSizes =
        audioItemSizes + '_' + (item.fileObj.size / 1024).toFixed(2) + 'kb';
    });
    sentGAEvent({
      category: 'audio_compress_output',
      action: 'audio_compress_output',
      label:
        audioCompressAfterList.length +
        '_' +
        quality +
        'kbps_' +
        format +
        audioItemSizes,
    });
    for (let i = 0; i < audioCompressAfterList.length; i++) {
      let audioCompressItem = audioCompressAfterList[i];
      audioCompressItem.quality = quality;
      let fileResponse;
      try {
        fileResponse = await this.requestUploadAudioFile(
          audioCompressItem.fileObj
        );
      } catch (error) {
        console.warn(error);
        if (error !== 'cancel') {
          audioCompressItem.status = 'failed';
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
        } else {
          this.setState({ compressing: false });
          return false;
        }
        continue;
      }
      if (fileResponse.code === 200) {
        sentGAEvent({
          category: 'UploadSuccess',
          action: '28AC_UploadSuccess',
          label: 'Null',
        });
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl = fileResponse.data.response_file[0];
          try {
            await Utils.getProgress(fileResponseNumber, false);
          } catch (error) {
            console.warn(error);
            if (error !== 'cancel') {
              audioCompressItem.status = 'failed';
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadAudio' + '_200_200_' + error,
              });
            } else {
              this.setState({ compressing: false });
              return false;
            }
            continue;
          }
          let compressResponse;
          try {
            compressResponse = await this.requstCompress(
              format,
              quality,
              fileResponseUrl
            );
          } catch (error) {
            console.warn(error);
            if (error !== 'cancel') {
              audioCompressItem.status = 'failed';
              sentGAEvent({
                category: 'audio_compress_output',
                action: 'audio_compress_output_failed',
                label:
                  error + '_none_none_' + this.props.tokenId + '_none_none',
              });
            } else {
              this.setState({ compressing: false });
              return false;
            }
            continue;
          }
          if (compressResponse.code === 200) {
            const compressResponseNumber = compressResponse.data.result.number;
            const compressResponseUrl = compressResponse.data.response_file[0];
            let compressProgressResponse;
            try {
              compressProgressResponse = await Utils.getProgress(
                compressResponseNumber,
                false
              );
              sentGAEvent({
                category: 'ProcessSuccess',
                action: '28AC_ProcessSuccess',
                label: 'Null',
              });
            } catch (error) {
              console.warn(error);
              if (error !== 'cancel') {
                audioCompressItem.status = 'failed';
                sentGAEvent({
                  category: 'audio_compress_output',
                  action: 'audio_compress_output_failed',
                  label: 'compressAudio' + '_200_200_' + error,
                });
              } else {
                this.setState({ compressing: false });
                return false;
              }
              continue;
            }
            if (compressResponse.code === 200) {
              sentGAEvent({
                category: 'ProcessStart',
                action: '28AC_ProcessStart',
                label: 'Null',
              });
            }
            audioCompressItem.status = 'success';
            audioCompressItem.size = compressProgressResponse.info[0].size;
            audioCompressItem.format = format;
            audioCompressItem.name = `${moment(new Date()).format(
              'YYYYMMDDHHmmss'
            )}.${format}`;
            audioCompressItem.downloadurl = compressResponseUrl;
          } else {
            if (compressResponse.code === 402102) {
              sentGAEvent({
                category: 'UpgradePrompShow',
                action: '28AC_UpgradePrompShow',
              });
              this.props.onPurchaseModalObjChange({
                visible: true,
                type: 'videoEditorTimesMoreThanLimit',
              });
              this.setState({
                compressing: false,
                audioCompressAfterList: [],
              });
              return;
            } else {
              audioCompressItem.status = 'failed';
            }
            sentGAEvent({
              category: 'audio_compress_output',
              action: 'audio_compress_output_failed',
              label:
                'compressAudio' +
                '_200_' +
                compressResponse.code +
                '_none_' +
                this.props.tokenId +
                '_none_' +
                compressResponse.msg,
            });
            continue;
          }
        }
      } else {
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadAudio' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        audioCompressItem.status = 'failed';
        if (fileResponse.code === 401) {
          Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
          let hostName = window.location.hostname;
          Cookies.remove('access_token', {
            domain: hostName.substring(
              window.location.hostname.indexOf('.'),
              hostName.length
            ),
          });
          Cookies.remove('access_token_expires_in', {
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.replace(
            `${accountList.get('login')}?redirect=${window.location.href}`
          );
        }
        continue;
      }
    }
    sentGAEvent({
      category: 'audio_compress_output',
      action: 'audio_compressing_time',
      label:
        audioCompressAfterList.length +
        '_' +
        moment(new Date().getTime()).diff(moment(startTime), 'seconds') +
        's',
    });
    let successNum = 0;
    let successAudioSizes = '';
    let failedAudioSizes = '';
    audioCompressAfterList.forEach((item) => {
      if (item.status === 'success') {
        successNum++;
        successAudioSizes =
          successAudioSizes + '_' + (item.size / 1024).toFixed(2) + 'kb';
      }
      if (item.status === 'failed') {
        failedAudioSizes =
          failedAudioSizes + '_' + (item.size / 1024).toFixed(2) + 'kb';
      }
    });
    if (successNum === 0) {
      this.setState({ submitStatus: 'failed' });
    } else if (successNum === audioCompressAfterList.length) {
      this.setState({ submitStatus: 'success' });
    } else {
      this.setState({ submitStatus: 'compelet' });
    }
    if (successNum !== 0) {
      sentGAEvent({
        category: 'audio_compress_output',
        action: 'audio_compress_output_success',
        label:
          successNum + '_' + quality + 'kbps_' + format + successAudioSizes,
      });
    }
    if (successNum !== audioCompressAfterList.length) {
      sentGAEvent({
        category: 'audio_compress_output',
        action: 'audio_compress_output_failed',
        label:
          audioCompressAfterList.length -
          successNum +
          '_' +
          quality +
          'kbps_' +
          format +
          failedAudioSizes,
      });
    }

    this.props.onProcessStepChange(0);
    this.props.onProcessPercentChange(0);
    this.props.onUploadPercentChange(0);
    this.setState({ compressing: false });
    this.setState({ audioCompressAfterList });
  };

  requstCompress = (format, quality, url) => {
    const formData = new FormData();
    formData.append('format', format);
    formData.append('quality', quality);
    formData.append('file_url', url);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`compressAudio`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadAudioFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    sentGAEvent({
      category: 'UploadStart',
      action: '28AC_UploadStart',
      label: 'Null',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadAudio`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadAudio_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  render() {
    console.log('audioCompressAfterList', this.state.audioCompressAfterList);
    return (
      <div className='workplace'>
        {!this.state.audioCompressAfterList.length ? (
          <AudioCompressWorkFunction
            audioCompressList={this.props.audioCompressList}
            deleteAudioCompressItem={this.deleteAudioCompressItem}
            uploadProps={this.props.uploadProps}
            handleStopUpload={this.props.handleStopUpload}
            handleSubmit={this.handleSubmit}
            compressing={this.state.compressing}
            cancelProcessCallBack={() => {
              this.setState({
                compressing: false,
                audioCompressAfterList: [],
              });
            }}
          />
        ) : (
          <AudioCompressCompleteFunction
            submitStatus={this.state.submitStatus}
            audioCompressAfterList={this.state.audioCompressAfterList}
            deleteAudioCompressAfterItem={this.deleteAudioCompressAfterItem}
            handleSubmitAgain={this.handleSubmitAgain}
          />
        )}
      </div>
    );
  }
}
const mapStateToPropos = (state) => ({
  audioCompressList: state.work.audioCompressList,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onAudioCompressListChange: (work) =>
    dispatch(actions.onAudioCompressListChange(work)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['audioCompress'])(AudioCompressWork));
